/**
 * @file path-edit-action.ts
 * @description Undo/redo action for SVG path node edits.
 * Stores before/after SVG strings and emits PATH_NODES_CHANGED on undo/redo.
 */

import { EventBus } from '@hcie/shared';

export class PathEditAction {
    constructor(
        private readonly shapeId: string,
        private readonly layerIndex: number,
        private readonly beforePath: string,
        private readonly afterPath: string
    ) {}

    undo(): void {
        EventBus.emit('PATH_NODES_CHANGED', {
            shapeId: this.shapeId,
            layerIndex: this.layerIndex,
            pathData: this.beforePath,
        });
    }

    redo(): void {
        EventBus.emit('PATH_NODES_CHANGED', {
            shapeId: this.shapeId,
            layerIndex: this.layerIndex,
            pathData: this.afterPath,
        });
    }
}
